import React, { useEffect, useState } from 'react';
import { superAdminApi } from '../../api/client';
import Spinner from '../../components/common/Spinner';
import { FaSearch, FaSchool, FaBan, FaCheck } from 'react-icons/fa';
import toast from 'react-hot-toast';

export default function Schools() {
  const [schools, setSchools] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch]   = useState('');
  const [status, setStatus]   = useState('');

  const load = () => {
    setLoading(true);
    superAdminApi.getSchools({ search, status, limit: 100 })
      .then(r => setSchools(r.data.data.schools))
      .catch(() => toast.error('Failed to load schools'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, [search, status]); // eslint-disable-line

  const toggleStatus = async (school) => {
    const newStatus = school.status === 'active' ? 'suspended' : 'active';
    try {
      await superAdminApi.setStatus({ school_id: school.school_id, status: newStatus });
      toast.success(`School ${newStatus}`);
      load();
    } catch { toast.error('Failed to update status'); }
  };

  return (
    <div>
      <div className="page-header">
        <h2>All Schools</h2>
        <p>Manage all schools registered on the platform</p>
      </div>

      {/* Filters */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 20 }}>
        <div style={{ position: 'relative', flex: 1, maxWidth: 360 }}>
          <FaSearch style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: '#9ca3af' }} />
          <input className="sms-input" style={{ paddingLeft: 36 }} placeholder="Search schools..."
            value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <select className="sms-input" style={{ width: 150 }} value={status} onChange={e => setStatus(e.target.value)}>
          <option value="">All Status</option>
          <option value="active">Active</option>
          <option value="suspended">Suspended</option>
        </select>
      </div>

      <div className="sms-card" style={{ padding: 0, overflow: 'hidden' }}>
        {loading ? <Spinner /> : (
          <table className="sms-table">
            <thead>
              <tr><th>School</th><th>Slug</th><th>Teachers</th><th>Learners</th><th>Status</th><th>Action</th></tr>
            </thead>
            <tbody>
              {schools.map(s => (
                <tr key={s.school_id}>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      {s.logo ? <img src={s.logo} alt="" style={{ width: 32, height: 32, borderRadius: 8, objectFit: 'cover' }} />
                        : <div style={{ width: 32, height: 32, borderRadius: 8, background: s.primary_color || '#0d6efd', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><FaSchool color="#fff" size={14} /></div>}
                      <span style={{ fontWeight: 500 }}>{s.name}</span>
                    </div>
                  </td>
                  <td style={{ fontFamily: 'monospace', color: '#6b7280' }}>{s.slug}</td>
                  <td>{s.total_teachers}</td>
                  <td>{s.total_learners}</td>
                  <td><span className={`sms-badge ${s.status === 'active' ? 'badge-present' : 'badge-absent'}`}>{s.status}</span></td>
                  <td>
                    <button onClick={() => toggleStatus(s)} className={`sms-btn sms-btn-sm ${s.status === 'active' ? 'sms-btn-danger' : 'sms-btn-outline'}`}>
                      {s.status === 'active' ? <><FaBan size={11} /> Suspend</> : <><FaCheck size={11} /> Activate</>}
                    </button>
                  </td>
                </tr>
              ))}
              {schools.length === 0 && <tr><td colSpan="6" style={{ textAlign: 'center', color: '#9ca3af', padding: '40px 0' }}>No schools found</td></tr>}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
